
import React from 'react'
import {useState, useEffect} from 'react'
import { ContentCopy} from "@mui/icons-material"
import {CustomTooltip} from  '../customtooltip/CustomTooltip'
import { Check } from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/StatusContext'

import "./aitest.css"

const CopyMoreAnswer = ({text}) => {
  const [isVisible, setIsVisible] = useState(false);

  const {
    isLoading,
    changeLanguage,
} = React.useContext(StatusContext);

const {
  moreanswer,
} = React.useContext(AITestContext);

  useEffect(() => {
    console.log("OnCopy: useEffect")
    // Show the icon immediately when the component mounts
    //setIsVisible(true);

    // Set a timer to hide the icon after 0.5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 500);

    // Cleanup the timer when the component unmounts or if it changes
    return () => clearTimeout(timer);
  }, [isVisible]); // Empty dependency array means this effect runs once on mount

  const onCopy = async () => {
    console.log("onCopy:", text)

    try {
        await navigator.clipboard.writeText(text);
        
        setIsVisible(true);
        //alert('Text copied to clipboard!');
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
}

  return (
    <div>
      {isVisible && <Check className="promptCopyIcon" />} {/* Display the icon if visible */}
      {!isVisible && 
        <>
     
        <CustomTooltip title={changeLanguage('status', 'copy')}>
          <ContentCopy
            className="promptCopyIcon"
            onClick={() => {
              !isLoading && onCopy(moreanswer);
            }}
          />
        </CustomTooltip>
      
      </>} {/* Display the icon if visible */}

    </div>
  );
};

export default CopyMoreAnswer;
  




